<template>
  <component :is="layout"></component>
</template>

<script>
import posterLayout from '../layouts/PosterLayout';
import rendererLayout from '../layouts/RendererLayout';

const DEFAULT_LAYOUT = 'poster';

export default {
  components: {
    posterLayout,
    rendererLayout,
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || DEFAULT_LAYOUT}Layout`;
    },
  },
};
</script>
